"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useConfirmationModal = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const components_1 = require("../components");
function useConfirmationModal() {
    const [content, setContent] = react_1.useState(null);
    const formActions = react_1.useRef(null);
    const noRef = react_1.useRef(null);
    const modal = react_1.useMemo(() => {
        var _a;
        return (jsx_runtime_1.jsxs(components_1.Modal, Object.assign({ size: "sm", leastDestructiveRef: noRef, isOpen: !!content, onDismiss: (_a = formActions.current) === null || _a === void 0 ? void 0 : _a.reject }, { children: [jsx_runtime_1.jsx(components_1.ModalHeader, { children: "Confirm" }, void 0),
                jsx_runtime_1.jsxs(components_1.ModalBody, { children: [jsx_runtime_1.jsx(components_1.Box, { children: content }, void 0),
                        jsx_runtime_1.jsxs(components_1.Flex, Object.assign({ mx: -1, mt: 3 }, { children: [jsx_runtime_1.jsx(components_1.Button, Object.assign({ flex: 1, mx: 1, backgroundColor: "success", color: "#fff", onClick: () => { var _a, _b; return (_b = (_a = formActions.current) === null || _a === void 0 ? void 0 : _a.accept) === null || _b === void 0 ? void 0 : _b.call(_a); } }, { children: "Yes" }), void 0),
                                jsx_runtime_1.jsx(components_1.Button, Object.assign({ flex: 1, mx: 1, ref: noRef, backgroundColor: "danger", color: "#fff", onClick: () => { var _a, _b; return (_b = (_a = formActions.current) === null || _a === void 0 ? void 0 : _a.reject) === null || _b === void 0 ? void 0 : _b.call(_a); } }, { children: "No" }), void 0)] }), void 0)] }, void 0)] }), void 0));
    }, [content]);
    const trigger = react_1.useCallback((content) => __awaiter(this, void 0, void 0, function* () {
        if (!content) {
            return Promise.resolve();
        }
        setContent(content);
        return new Promise((resolve, reject) => {
            formActions.current = {
                accept: () => {
                    setContent(null);
                    formActions.current = null;
                    resolve();
                },
                reject: () => {
                    setContent(null);
                    formActions.current = null;
                    reject(new Error('Confirmation rejected.'));
                },
            };
        });
    }), []);
    const dismiss = react_1.useCallback(() => {
        var _a, _b;
        (_b = (_a = formActions.current) === null || _a === void 0 ? void 0 : _a.reject) === null || _b === void 0 ? void 0 : _b.call(_a);
    }, []);
    return react_1.useMemo(() => [modal, trigger, { dismiss }], [dismiss, modal, trigger]);
}
exports.useConfirmationModal = useConfirmationModal;
//# sourceMappingURL=useConfirmationModal.js.map